import GeoMoverDB from '@/db/indexeddb'

export default {
  setAllTrackedRoutes ({ commit }, payload) {
    commit('SET_ALL_TRACKED_ROUTES', payload)
  },
  // same as before, but initiated from "NewActivity" after saving
  async updateAllTrackedRoutes ({ commit }) {
    const data = await GeoMoverDB.findAll('trackedRoutes', 'date', 'desc')
    commit('SET_ALL_TRACKED_ROUTES', data)
  },
  setShowTrack ({ commit }, bool) {
    commit('SET_SHOW_TRACK', bool)
  }
}
